import { combineReducers } from "@reduxjs/toolkit";
import { maintenanceOrderTooltipSlice } from './maintenanceOrderTooltipSlice'
import fetchOperationOrderSlice from "./fetchOperationOrderSlice";

export const operationRootReducer = combineReducers({
  maintenanceOrderTooltip: maintenanceOrderTooltipSlice.reducer,
  fetchOperationOrder: fetchOperationOrderSlice.reducer
});